import {
  Facebook,
  Twitter,
  Instagram,
  Youtube,
  Linkedin,
  Music2,
  MessageCircle,
  Mail,
  Phone,
  MapPin,
} from "lucide-react";

// 10 redes sociales / canales de contacto
const SOCIAL = [
  { label: "Facebook", Icon: Facebook, href: "#" },
  { label: "X (Twitter)", Icon: Twitter, href: "#" },
  { label: "Instagram", Icon: Instagram, href: "#" },
  { label: "YouTube", Icon: Youtube, href: "#" },
  { label: "LinkedIn", Icon: Linkedin, href: "#" },
  { label: "TikTok", Icon: Music2, href: "#" },
  { label: "Chat", Icon: MessageCircle, href: "#" },
  { label: "Email", Icon: Mail, href: "mailto:antoybella-mundo@group-hiperconvercloud.com" },
  { label: "Teléfono", Icon: Phone, href: "tel:5588967667" },
  { label: "Ubicación", Icon: MapPin, href: "#" },
];

export const SocialLinks = () => (
  <div className="flex flex-wrap gap-2.5" data-testid="social-links">
    {SOCIAL.map(({ label, Icon, href }, i) => (
      <a
        key={label}
        href={href}
        target={href.startsWith("http") ? "_blank" : undefined}
        rel="noreferrer"
        aria-label={label}
        title={label}
        data-testid={`social-${label.toLowerCase().replace(/[^a-z]/g, "")}`}
        className="flex h-10 w-10 items-center justify-center rounded-full bg-white/10 text-cream/80 ring-1 ring-white/10 transition-all duration-300 hover:-translate-y-0.5 hover:bg-coral hover:text-white hover:ring-coral"
      >
        <Icon className="h-4 w-4" strokeWidth={2} />
      </a>
    ))}
  </div>
);
